import styled from '@emotion/styled';

export const ImageCollageWrapper = styled.div`
  margin-top: 64px;
  margin-bottom: 58px;
  p {
    max-width: 100%;
  }
`;
